"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IncompleteCart_1 = require("./IncompleteCart");
exports.default = IncompleteCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/IncompleteCart/index.js
// module id = 788
// module chunks = 8